import { useAsyncValue } from 'framework/utils';
import { CROP_SIZES, FILE_CATEGORY } from '../../../constants';
import { InputLoader } from 'framework/ui/mui-builder';
import { useState } from 'react';
import { DownloadButton, FileName } from 'framework/documentStorage';

type ImageLayoutProps = {
  value: any;
  getThumbnail: (id: number | string, size: string) => Promise<Nullable<string>> | Nullable<string> | void;
  handleClick: () => void;
  handleDownload?: () => void;
};

const ImageLayout = ({
  value,
  getThumbnail = async () => null,
  handleClick = () => {},
  handleDownload = () => Promise.reject('No file'),
}: ImageLayoutProps) => {
  const [loading, setLoading] = useState(false);

  const thumbnail = useAsyncValue(async () => {
    if (!value) {
      return FILE_CATEGORY.DEFAULT.icon;
    }

    try {
      const resolvedThumbnail = await getThumbnail(value.id, CROP_SIZES.SIZE_100);
      return resolvedThumbnail || FILE_CATEGORY.DEFAULT.icon;
    } catch {
      return FILE_CATEGORY.DEFAULT.icon;
    }
  });

  const onClick = async () => {
    setLoading(true);
    await handleDownload();
    setLoading(false);
  };

  if (!value) {
    return null;
  }

  return (
    <>
      <button onClick={handleClick} type="button">
        {thumbnail ? (
          <>
            <span className="files-list__files-image">
              <img src={thumbnail} alt={value.title} title={value.title} id={value.id} data-testid="artifact-image" />
            </span>
            <FileName title={value.title} />
          </>
        ) : (
          <InputLoader className="files-list__files-loader" />
        )}
      </button>
      <DownloadButton onClick={onClick} loading={loading} />
    </>
  );
};

export default ImageLayout;
